/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'pip-events',
    'utils.url',
    'pip-analytics__hddata'
],
function(
    $,
    pip,
    pipEvents,
    utilsURL,
    hddata
){

    //TODO: The entire way breadcrumbs are rendered needs to be refactored

	var ajaxUrlParams = {};
	var ajaxUrl = '/p/svcs/getProductBreadCrumbData';
	var paramFlag = false;
	var backToLocalAdTemplate = '<div id="backToLocalAd"><a>Back to Local Ad</a></div>';
	var bcData = {
		bcEnsightenData: {},
		bcLivePersonData: {}
	};


	function initializeFields() {
		var navParam = utilsURL.get({
			url: window.location.href,
			lookupParm: 'N'
		});

		if(navParam && navParam.length) {
			ajaxUrlParams.navParam = navParam;
			paramFlag = true;
		}
		if(paramFlag) {
			ajaxUrl += '?';
			ajaxUrl += unescape($.param(ajaxUrlParams));
		}
	}

	function loadHierarchy() {
		$.ajax({
			url: ajaxUrl,
			dataType: 'json',
			async: true,
			success: function(data) {
				if(data.bcHtml && data.bcHtml.length) {
					processBreadCrumbData(data);
					// GLOBAL -- need to do server side (Wes)
				} else if(BREADCRUMB_JSON) {
					processBreadCrumbData(BREADCRUMB_JSON);
				}
			}
		});
	}

	function processBreadCrumbData(data) {
		bcData = data || BREADCRUMB_JSON;
		renderBreadCrumbs();
		initializeEnsighten();
		pipEvents.breadcrumbs.breadcrumbsLoaded.trigger();
	}

    function getBreadcrumbProductIdTemplate() {
        return '<li class="breadcrumb__item breadcrumb__item--not-a-link">Internet #' + pip.products.primary.data.itemId + '</li>';
    }

	function renderBreadCrumbs() {
	    if(pip.platform === 'MOBILE'){
            $('#header-crumb').append(bcData.bcHtml);
            $('#header-crumb').append(getBreadcrumbProductIdTemplate());
            $('#breadcrumb').css('margin-top', 0);
        } else {
            $('#header-crumb').append(bcData.bcHtml);
        }
	}

	function initializeEnsighten() {
		_hddata["contentSubCategory"] = bcData.bcEnsightenData.contentSubCategory;
		_hddata["contentCategory"] = bcData.bcEnsightenData.contentCategory;
		_hddata["siteSection"] = bcData.bcEnsightenData.siteSection;
		_hddata.map["Hierarchy"] = true;
		if (window.hddataReady) window.hddataReady();
	}

	function showBackToLocalAd(href) {
		$('#header-crumb').after($(backToLocalAdTemplate).find('a').attr('href', href).parent());
	}


	return {
		init: function() {
			var localAdUrl = utilsURL.get({
				url: window.location.href,
				lookupParm: 'localadurl'
			});

			initializeFields();
			if(paramFlag){
				loadHierarchy();
			}else if(BREADCRUMB_JSON){
				processBreadCrumbData();
			}
			if(localAdUrl){
				showBackToLocalAd(decodeURIComponent('http://localad.homedepot.com' + localAdUrl));
			}
		},
		getBreadcrumbData: function(){
			return bcData;
		}


	}

});

}.call(window));